import React from 'react';

import { Content } from '../Content';

import { parseHTML } from '../../services/parseHTML';

import { replaceShortcodes } from '../../services/replaceShortcodes';
import { useStoreData } from '../../hooks';

interface MarkdownProps {
    content: string;
}

export const Markdown: React.FC<MarkdownProps> = ({ content, ...props }) => {
    const storeDataShortcodes = useStoreData().user.shortcodes;

    return (
        <Content {...props}>
            {parseHTML(
                replaceShortcodes(content, storeDataShortcodes),
                'markdown',
            )}
        </Content>
    );
};
